import { render } from "./AlertsManager.vue?vue&type=template&id=11b637cc&scoped=true"
import script from "./AlertsManager.vue?vue&type=script&lang=js"
export * from "./AlertsManager.vue?vue&type=script&lang=js"

import "./AlertsManager.vue?vue&type=style&index=0&id=11b637cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b637cc"]])

export default __exports__